module.exports = __webpack_public_path__ + "img/错误.34014e84.png";